import CheckIcon from "@mui/icons-material/Check"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import CloseIcon from "@mui/icons-material/Close"
import React from "react"

export const COINS = [
  { label: "Select Coins", value: 0 },
  { label: "1 Coin", value: 1 },
  { label: "5 Coins", value: 5 },
  { label: "10 Coins", value: 10 },
  { label: "15 Coins", value: 15 },
  { label: "20 Coins", value: 20 },
  { label: "25 Coins", value: 25 },
  { label: "50 Coins", value: 50 },
  { label: "100 Coins", value: 100 }
]

export const initialValue = {
  name: "",
  scope: "All Restaurant",
  created_by: "",
  start_date: "",
  end_date: "",
  creation_date: "",
  quiz_coins: 0,
  flash_cards_coins: 0
}

export const difficultyLevelChoices = [
  { label: "Beginner", value: "Beginner" },
  { label: "Intermediate", value: "Intermediate" },
  { label: "Advance", value: "Advance" }
]

export const BeverageSubCategories = [
  {
    label: "Bar",
    value: "Bar"
  },
  {
    label: "Spirits",
    value: "Spirits"
  },
  {
    label: "Wine By Glass",
    value: "Wine By Glass"
  }
]

export const FoodSubCategories = [
  {
    label: "Lunch",
    value: "Lunch"
  },
  {
    label: "Dinner",
    value: "Dinner"
  }
]

export const WineRegionSubCategories = [
  {
    label: "Wine Region",
    value: "Wine Region"
  }
]

export const SpecialSubCategories = [
  {
    label: "Special",
    value: "Special"
  }
]

export const statusOptions = {
  open_comments: [
    {
      label: "Resolve",
      menuTitle: "Mark as Resolved",
      status: "resolved",
      icon: <CheckIcon />,
      tooltip: "Please select at least one comment to resolve"
    },
    {
      label: "Irrelevant",
      menuTitle: "Mark as Irrelevant",
      status: "irrelevant",
      icon: <CloseIcon />,
      tooltip: "Please select at least one comment to irrelevant"
    }
  ],
  resolved_comments: [
    {
      label: "Open",
      menuTitle: "Mark as Open",
      status: "unresolved",
      icon: <InfoOutlinedIcon />,
      tooltip: "Please select at least one comment to open"
    },
    {
      label: "Irrelevant",
      menuTitle: "Mark as Irrelevant",
      status: "irrelevant",
      icon: <CloseIcon />,
      tooltip: "Please select at least one comment to irrelevant"
    }
  ],
  irrelevant_comments: [
    {
      label: "Open",
      menuTitle: "Mark as Open",
      status: "unresolved",
      icon: <InfoOutlinedIcon />,
      tooltip: "Please select at least one comment to open"
    },
    {
      label: "Resolved",
      menuTitle: "Mark as Resolved",
      status: "resolved",
      icon: <CheckIcon />,
      tooltip: "Please select at least one comment to resolve"
    }
  ]
}

export const categoryType = [
  {
    value: "FOOD",
    label: "Food"
  },
  {
    value: "COCKTAILS",
    label: "Cocktails"
  },
  {
    value: "WINE",
    label: "Wine"
  },
  {
    value: "WINE_REGION",
    label: "Wine Region"
  },
  {
    value: "HOTEL",
    label: "Hotel"
  },
  {
    value: "OTHER",
    label: "Other"
  }
]
export const expandedNationalLeaderboardColumns = {
  total_coins: [
    "trivia_coins",
    "quiz_coins",
    "bonus_coins",
    "weekly_coins",
    "daily_practice_coins",
    "wine_region_coins",
    "mistake_coins",
    "history_weekly_coins"
  ]
}

export const NationalLeaderboardColumns = [
  {
    id: "rank",
    label: "#",
    align: "center",
    minWidth: 50
  },
  {
    id: "name",
    label: "Name",
    minWidth: 200
  },
  {
    id: "restaurant",
    label: "Restaurant",
    align: "center",
    minWidth: 130
  },
  {
    id: "role",
    label: "Role",
    align: "center",
    minWidth: 120
  },
  {
    id: "streaks",
    label: "Streak Count",
    align: "center",
    minWidth: 160,
    isSorting: true,
    sortId: "streaks"
  },
  {
    id: "quizzes_played",
    label: "Quiz Taken",
    align: "center",
    minWidth: 160,
    isSorting: true,
    sortId: "quizzes_played"
  },
  {
    id: "total_coins",
    label: "Total Coins Earned",
    align: "center",
    minWidth: 220,
    isSorting: true,
    sortId: "total_coins",
    expandAction: true
  },
  {
    id: "trivia_coins",
    label: "Trivia Coins",
    align: "center",
    minWidth: 135,
    isSorting: true,
    sortId: "trivia_coins",
    isHidden: true
  },
  {
    id: "quiz_coins",
    label: "Quiz Coins",
    align: "center",
    minWidth: 135,
    isSorting: true,
    sortId: "quiz_coins",
    isHidden: true
  },
  {
    id: "bonus_coins",
    label: "Bonus Coins",
    align: "center",
    minWidth: 145,
    isSorting: true,
    sortId: "bonus_coins",
    isHidden: true
  },
  {
    id: "weekly_coins",
    label: "Weekly Coins",
    align: "center",
    minWidth: 155,
    isSorting: true,
    sortId: "weekly_coins",
    isHidden: true
  },
  {
    id: "daily_practice_coins",
    label: "Daily Practice Coins",
    align: "center",
    minWidth: 200,
    isSorting: true,
    sortId: "daily_practice_coins",
    isHidden: true
  },
  {
    id: "wine_region_coins",
    label: "Wine Region Coins",
    align: "center",
    minWidth: 200,
    isSorting: true,
    sortId: "wine_region_coins",
    isHidden: true
  },
  {
    id: "mistake_coins",
    label: "Mistake Coins",
    align: "center",
    minWidth: 155,
    isSorting: true,
    sortId: "mistake_coins",
    isHidden: true
  },
  {
    id: "history_weekly_coins",
    label: "History Weekly Coins",
    align: "center",
    minWidth: 200,
    isSorting: true,
    sortId: "history_weekly_coins",
    isHidden: true
  },
  {
    id: "company_rank",
    label: "Company Ranking",
    align: "center",
    minWidth: 180,
    isSorting: true,
    sortId: "company_rank"
  },
  {
    id: "national_rank",
    label: "National Ranking",
    align: "center",
    minWidth: 165,
    isSorting: true,
    sortId: "national_rank"
  }
]

export const did_you_know_initial_values = {
  heading: "",
  content: "",
  image: ""
}

export const history_initial_values = {
  heading: "",
  content: ""
}

export const podsColumns = [
  {
    id: "drag",
    label: "",
    minWidth: 60,
    align: "left"
  },
  {
    id: "name",
    label: "NAME",
    minWidth: 300,
    align: "left"
  },
  {
    id: "restaurant",
    label: "RESTAURANT",
    minWidth: 200,
    align: "left"
  },
  {
    id: "role",
    label: "Role",
    minWidth: 100,
    align: "left"
  }
]
export const leagueColumns = [
  {
    id: "id",
    label: "#",
    minWidth: 50,
    align: "center"
  },
  {
    id: "podName",
    label: "Pod Name",
    minWidth: 120,
    align: "left"
  },
  {
    id: "restaurants",
    label: "Restaurants",
    minWidth: 250,
    align: "left"
  },
  {
    id: "startDate",
    label: "Start Date",
    minWidth: 120,
    align: "left"
  },
  {
    id: "endDate",
    label: "End Date",
    minWidth: 120,
    align: "left"
  },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
    align: "left"
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 80,
    align: "center"
  }
]

export const podsOptions = [
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "8", value: "8" },
  { label: "10", value: "10" }
]

export const tabs = [
  { label: "Summary", value: "summary" },
  { label: "Played Games", value: "games_played" },
  { label: "Menu Only", value: "menu_only" },
  { label: "Only Logged In", value: "only_logged_in" },
  { label: "Did Nothing", value: "did_nothing" },
  { label: "Preshift", value: "preshift_views" }
]

export const cards = [
  {
    label: "Count",
    value: "count"
  },
  {
    label: "Numerator",
    value: "numerator"
  },
  {
    label: "Denominator",
    value: "denominator"
  },
  {
    label: "Percentage",
    value: "percentage"
  }
]

export const summaryColumns = [
  { id: "Metrics", label: "Metrics", minWidth: 100, align: "left" },
  { id: "Count", label: "Count", minWidth: 100, align: "center" },
  {
    id: "Numerator",
    label: "Numerator",
    minWidth: 100,
    align: "center",
    tooltip: "Number of users who engaged in the activity"
  },
  {
    id: "Denominator",
    label: "Denominator",
    minWidth: 100,
    align: "center",
    tooltip: "Total number of users"
  },
  {
    id: "Percentage",
    label: "Percentage",
    minWidth: 100,
    align: "center",
    tooltip: "Numerator * 100 / Denominator = Percentage"
  }
]

export const defaultColumns = [
  { id: "rank", label: "#", minWidth: 40, align: "center" },
  { id: "name", label: "Name", minWidth: 150, align: "left" },
  { id: "email", label: "Email", minWidth: 200, align: "left" }
]

export const tableColumnsMap = {
  Summary: summaryColumns,
  games_played: defaultColumns,
  menu_only: defaultColumns,
  only_logged_in: defaultColumns,
  did_nothing: defaultColumns,
  preshift_views: defaultColumns
}

export const metrics = [
  {
    label: "Total Available Users",
    key: "total_active_users",
    isTooltip: true,
    tooltip: "Total number of frontline users with raffle access."
  },
  { label: "Played Games", key: "games_played", isTooltip: true, tooltip: "Played Games" },
  {
    label: "Menu Only",
    key: "menu_only",
    isTooltip: true,
    tooltip: "Users who viewed the menu but did not play any games."
  },
  {
    label: "Only Logged In",
    key: "only_logged_in",
    isTooltip: true,
    tooltip: "Users who logged into the app but did not play games or view the menu."
  },
  {
    label: "Did Nothing",
    key: "did_nothing",
    isTooltip: true,
    tooltip: "Users who neither played games nor viewed the menu."
  },
  {
    label: "Engaged Users",
    key: "engaged_users",
    isTooltip: true,
    tooltip:
      "Users who played at least one game (Weekly Challenge, Wine Region, Daily Practice, Quiz, etc.)."
  }
]

export const metricsOptions = [
  { label: "Weekly Challenges Played", value: "weekly_challenge_played" },
  { label: "Available Users", value: "available_users" },
  { label: "Active Users", value: "active_users" },
  { label: "Quizzes Launched", value: "quizzes_launched" },
  { label: "Quiz Games", value: "quiz_games" },
  { label: "Flashcard Questions Played", value: "flashcard_played" },
  { label: "Total Games Played", value: "total_games_played" },
  { label: "Random Questions Played", value: "daily_practice" },
  { label: "Wine Region Attempts", value: "wine_region_attempts" },
  { label: "Mistake Attempts", value: "mistake_attempts" },
  { label: "History Challenges", value: "history_challenges" },
  { label: "Engagement Percentage", value: "engagement_percentage" },
  { label: "Weekly Quiz Questions", value: "weekly_quiz_questions" },
  { label: "Played Games", value: "played_games" },
  { label: "Menu Only", value: "menu_only" },
  { label: "Only Logged In", value: "only_logged_in" },
  { label: "Did Nothing", value: "did_nothing" },
  { label: "AWOL", value: "awol_users" },
  { label: "Preshift Opens", value: "preshift_card" },
  { label: "Preshift Only", value: "preshift_only" }
]

export const summaryGroups = [
  { label: "Played Games", key: "played_games" },
  { label: "Menu Only", key: "menu_only" },
  { label: "Only Logged In", key: "only_logged_in" },
  { label: "Did Nothing", key: "did_nothing" },
  { label: "Preshift Opens", key: "preshift_card" },
  { label: "Preshift Only", key: "preshift_only" }
]

export const objectMetrics = {
  quiz_games: ["total", "weekly", "vip"],
  flashcard_played: ["total", "correct", "incorrect"]
}

export const vipPermissionColumns = [
  {
    id: "#",
    label: "#",
    minWidth: 40
  },
  {
    id: "User Name",
    label: "User Name",
    minWidth: 160
  },
  {
    id: "Role",
    label: "Roles",
    minWidth: 120,
    align: "center"
  },
  {
    id: "Email",
    label: "Email",
    align: "center",
    minWidth: 200
  },
  {
    id: "Approval Status",
    label: "Approval Status",
    align: "center",
    minWidth: 40
  }
]

export const rewardsPermissionColumns = [
  {
    id: "#",
    label: "#",
    minWidth: 40
  },
  {
    id: "User Name",
    label: "User Name",
    minWidth: 160
  },
  {
    id: "Role",
    label: "Roles",
    minWidth: 120,
    align: "center"
  },
  {
    id: "Email",
    label: "Email",
    align: "center",
    minWidth: 200
  },
  {
    id: "Permission",
    label: "Permission",
    align: "center",
    minWidth: 40
  }
]

export const vipConfigurationColumns = [
  {
    id: "#",
    label: "#",
    minWidth: 40
  },
  {
    id: "Name",
    label: "Name",
    minWidth: 160,
    align: "left"
  },
  {
    id: "category",
    label: "Category",
    minWidth: 120,
    align: "center"
  },
  {
    id: "Time",
    label: "Arriving Time",
    minWidth: 120,
    align: "center"
  },
  {
    id: "Day",
    label: "Arriving Day",
    minWidth: 120,
    align: "center"
  },
  { id: "mobile_status", label: "Mobile Status", minWidth: 80, align: "center" },
  { id: "cms_status", label: "CMS Status", minWidth: 80, align: "center" },
  {
    id: "actions",
    label: "Actions",
    minWidth: 80,
    align: "center"
  }
]

export const notableVipGroupColumns = [
  {
    id: "#",
    label: "#",
    minWidth: 40,
    align: "center"
  },
  {
    id: "Event Title",
    label: "Event Title",
    minWidth: 160,
    align: "left"
  },
  {
    id: "Description",
    label: "Description",
    minWidth: 160,
    align: "center"
  },
  {
    id: "Dates",
    label: "Dates",
    minWidth: 100,
    align: "center"
  },
  {
    id: "Actions",
    label: "Actions",
    minWidth: 80,
    align: "center"
  }
]

export const notableGroupManagementColumns = [
  {
    id: "#",
    label: "#",
    minWidth: 40
  },
  {
    id: "Group Name",
    label: "Group Name",
    minWidth: 160,
    align: "left"
  },
  {
    id: "Industry / Focus",
    label: "Industry / Focus",
    minWidth: 160,
    align: "center"
  },
  {
    id: "Dates",
    label: "Dates",
    minWidth: 100,
    align: "center"
  },
  {
    id: "Actions",
    label: "Actions",
    minWidth: 80,
    align: "center"
  }
]

export const menuUploadType = [
  { label: "PDF", value: "pdf" },
  { label: "DOC", value: "docx" },
  { label: "CSV", value: "csv" }
]

export const tierColumns = ["Tier", "Unlock Type", "Status", "Actions"]

export const unlockLogicItems = [
  { label: "Coins Only", value: "coinsOnly" },
  { label: "Streak Only", value: "streakOnly" },
  { label: "Either Coins Or Streaks", value: "coinsAndStreak" }
]

export const categoryColumns = [
  { id: "categoryName", label: "Category Name", minWidth: 40, align: "left" },
  { id: "giftCards", label: "Gift Cards", minWidth: 100, align: "left" },
  { id: "status", label: "Status", minWidth: 100, align: "left" },
  { id: "createdAt", label: "Created At", minWidth: 100, align: "center" },
  { id: "actions", label: "Actions", minWidth: 100, align: "right" }
]

export const rewardManagementColumns = [
  { id: "ID", label: "", minWidth: 40, align: "left" },
  { id: "Reward", label: "Reward", minWidth: 100, align: "left" },
  { id: "Tier", label: "Tier", minWidth: 100, align: "left" },
  { id: "Status", label: "Status", minWidth: 100, align: "left" },
  { id: "Total Quantity", label: "Total Quantity", minWidth: 100, align: "left" },
  { id: "Available Quantity", label: "Available Quantity", minWidth: 100, align: "left" },
  { id: "Claimed", label: "Claimed", minWidth: 100, align: "left" },
  { id: "Pending", label: "Pending", minWidth: 100, align: "left" },
  { id: "Rejected", label: "Rejected", minWidth: 100, align: "left" },
  { id: "Actions", label: "Actions", minWidth: 100, align: "right" }
]

export const analyticsDashboardColumns = [
  { id: "Reward Title", label: "Reward Title", minWidth: 150, align: "left" },
  { id: "Tier", label: "Tier", minWidth: 100, align: "left" },
  { id: "Redemptions", label: "Redemptions", minWidth: 100, align: "right" },
  { id: "Coins Spent", label: "Coins Spent", minWidth: 100, align: "right" }
]

export const sectionTypes = [
  { label: "Custom", value: "CUSTOM" },
  { label: "Notes", value: "NOTES" },
  { label: "Text", value: "TEXT" },
  { label: "VIP Guests", value: "VIP_GUESTS" },
  { label: "Floor Plan", value: "FLOOR_PLAN" },
  { label: "Shift Report", value: "SHIFT_REPORT" }
]

export const fieldTypes = [
  { label: "Number", value: "number" },
  { label: "File", value: "image" },
  { label: "Rich Text", value: "rich_text" },
  { label: "Menu Items", value: "items" }
]

export const preshiftColumns = [
  { id: "id", label: "#", minWidth: 50, align: "center" },
  { id: "name", label: "Name", minWidth: 200, align: "left" },
  { id: "updated_by", label: "Last Updated By", minWidth: 160, align: "center" },
  { id: "updated_at", label: "Last Updated At", minWidth: 160, align: "center" },
  { id: "status", label: "Status", minWidth: 120, align: "center" },
  { id: "actions", label: "Actions", minWidth: 80, align: "center" }
]

export const restaurantConfigurationColumns = [
  { key: "lite", label: "Lite Mode" },
  { key: "new_user_journey", label: "New User Journey" },
  { key: "new_user_journey_cms", label: "New User Journey CMS" },
  { key: "rewards_enabled", label: "Rewards Enabled" },
  { key: "enable_preshift_card", label: "Enable Pre-shift Card" }
]

export const timeZones = [
  "UTC",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Honolulu",
  "America/Phoenix",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "Asia/Kolkata",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Asia/Dubai",
  "Australia/Sydney",
  "Pacific/Auckland"
]

export const restaurantColumns = [
  { id: "Restaurant", label: "Restaurant", minWidth: 200 },
  { id: "Group", label: "Group", minWidth: 150 },
  { id: "Location", label: "Location", minWidth: 150 },
  { id: "Timezone", label: "Timezone", minWidth: 150 },
  { id: "Lite", label: "Lite", minWidth: 80, align: "left" },
  { id: "New User Journey", label: "New User Journey", minWidth: 120, align: "left" },
  { id: "Rewards", label: "Rewards", minWidth: 100, align: "left" },
  { id: "Actions", label: "Actions", minWidth: 80, align: "center" }
]

export const groupColumns = [
  { id: "Group", label: "Group", minWidth: 200 },
  { id: "Email", label: "Email", minWidth: 200 },
  { id: "Domain", label: "Domain", minWidth: 200 },
  { id: "Restaurants", label: "Restaurants", minWidth: 120 },
  { id: "Actions", label: "Actions", minWidth: 80, align: "center" }
]

export const fieldTypeDescriptions = {
  number: "Captures a numeric value — useful for cover count, table numbers, or any quantity.",
  image: "Allows uploading a file or image directly into the section.",
  rich_text:
    "A full-featured text editor supporting formatting, bullet lists, bold, italics, and more.",
  items:
    "Lets staff attach menu items (food, drinks, or wine) to this section with live pricing and details."
}

export const sectionTypeGuide = [
  {
    key: "CUSTOM",
    label: "Custom",
    tag: "Editable",
    description:
      "A blank canvas — add any combination of fields (number, rich text, file, menu items) to match your briefing needs."
  },
  {
    key: "NOTES",
    label: "Notes",
    tag: "Editable",
    description:
      "A freeform notes section for staff briefing content. Multiple Notes sections can coexist per restaurant."
  },
  {
    key: "TEXT",
    label: "Text",
    tag: "Editable",
    description:
      "Comes pre-configured with a single rich text editor field. Ideal for formatted announcements or descriptions."
  },
  {
    key: "COVERS",
    label: "Covers",
    tag: "System",
    description:
      "Displays lunch, dinner, and total cover counts for the shift. Auto-generated and supports custom fields."
  },
  {
    key: "VIP_GUESTS",
    label: "VIP Guests",
    tag: "System",
    description:
      "Automatically pulls in approved VIP guest details (name, arrival time, notes) from the VIP module."
  },
  {
    key: "FLOOR_PLAN",
    label: "Floor Plan",
    tag: "System",
    description:
      "Shows the restaurant floor plan image uploaded for the shift. Only one instance allowed per restaurant."
  },
  {
    key: "COVER_FLOW",
    label: "Cover Flow",
    tag: "System",
    description:
      "Displays pacing and cover flow data as a chart. Only one instance allowed per restaurant."
  }
]

export const raffleWinnersColumns = [
  { id: "index", label: "#", minWidth: 60, align: "center" },
  { id: "winner_name", label: "Winner Name", minWidth: 180 },
  { id: "raffle_month", label: "Raffle Month", minWidth: 140, align: "center" },
  { id: "prize_claimed", label: "Prize Claimed", minWidth: 220, align: "center" },
  { id: "created_at", label: "Won At", minWidth: 160, align: "center" },
  { id: "action", label: "Action", align: "center", minWidth: 80 }
]

export const shoppingSpreeColumns = [
  {
    id: "start_datetime",
    label: "Spree Start Date",
    minWidth: 250,
    align: "left"
  },
  { id: "end_datetime", label: "Spree End Date", minWidth: 250, align: "left" },
  { id: "status", label: "Status", minWidth: 100, align: "left" },
  { id: "actions", label: "Actions", minWidth: 50, align: "center" }
]
